import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import React from "react";
import Navbar from "../../components/Navbar";
import Banner from "../../components/Banner";
import Footer from "../../components/Footer";
type AboutProps = {};
const About: React.FC<AboutProps> = () => {
  return (
    <>
      <Flex w="100%" h="100vh" direction="column">
        <Navbar />
        <Banner />
        <br />
        <br />
        <Heading
          fontWeight="extrabold"
          align="center"
          fontFamily="Poppins, sans-serif"
        >
          About Us
        </Heading>
      </Flex>
      {/* ABOUT SECTION */}
      <Flex p={10} direction="column" justifyContent="space-between" h="100%">
        <Flex w="100%" h="100%">
          <Box boxSize="50%" p={10}>
            <Heading>About</Heading>
            <Text fontSize="2xl">
              We are a proudly South African Level 1 B-BBEE Company We pride
              ourselves on being a 100% Black Designated Women Owned Business We
              believe in the our beautiful country and work toward aligning
              ourselves and our stakeholders to the National Development Plan We
              strive to promote transformation in the workplace We are
              passionate about creating employment opportunities through various
              initiatives We work hard to form synergies between multiple
              organizations and communities which we align to our client’s
              strategic objectives We do our utmost to conceptualize and promote
              opportunities in collaboration with our clients for Black Women,
              young people and persons living with disabilities who have been
              marginalized in society
            </Text>
          </Box>
          <Box
            boxSize="lg"
            w="45%"
            bgImage="/img/plant.jpeg"
            bgSize="contain"
            bgRepeat="no-repeat"
          ></Box>
        </Flex>
        <br />
        <br />
        {/* MISSIONS AND VALUES */}
        <Flex>
          <Box boxSize="lg" w="50%" align="center">
            <img
              src="/img/creative.jpeg"
              alt=""
              style={{
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                height: "100%",
              }}
            />
          </Box>
          <Box boxSize="55%">
            <Text fontSize="2xl">
              <Heading>Our Mission Vision and Values</Heading>
              It is our view that “Utilizing the power of community is truly the
              catalyst that will evoke change, equality and empowerment”. At
              HRBEE we are passionate about people and their development. We
              believe that we have the necessary expertise to foster and empower
              all our stakeholders with the aim of upholding and promoting the
              constitution of our beloved country by augmenting the tenets of
              Broad Based Black Economic Empowerment. We seek to maximize the
              potential of women, young unemployed black people and suppliers by
              providing them with the skills training, business opportunities
              and mentoring services. We aim to find innovative ways to do
              business in impoverished rural and semi-urban areas that empowers
              communities including people with disabilities.
            </Text>
          </Box>
        </Flex>
      </Flex>
      <Footer />
    </>
  );
};
export default About;
